import React from "react";
import { Lock, Eye, EyeOff, ShieldCheck } from "lucide-react";
import { useAdminAuth } from "./auth";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const [pwd, setPwd] = React.useState("");
  const [show, setShow] = React.useState(false);
  const [err, setErr] = React.useState("");

  const submit = (e) => {
    e.preventDefault();
    setErr("");
    const ok = login(pwd);
    if (!ok) setErr("That password is incorrect. Only the owner can access the admin.");
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16 px-5">
      <div className="w-full max-w-md">
        <div className="card-soft p-8 relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full bg-[#c7e34a]/10 blur-3xl pointer-events-none" />
          <div className="relative">
            <div className="w-14 h-14 rounded-2xl bg-[#c7e34a]/15 border border-[#c7e34a]/30 flex items-center justify-center text-[#c7e34a] mb-5">
              <ShieldCheck className="w-7 h-7" />
            </div>
            <span className="kicker">Owner access only</span>
            <h1 className="font-serif-display text-white text-3xl mt-3 mb-2">Admin sign-in</h1>
            <p className="text-slate-400 text-sm mb-6">Enter the owner password to manage website content, bookings, and subscribers.</p>

            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs text-slate-400 mb-1 block">Password</label>
                <div className="relative">
                  <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                  <input autoFocus type={show ? "text" : "password"} value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                    className="w-full bg-[#0b1220] border border-white/10 rounded-xl pl-10 pr-11 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:border-[#c7e34a]/60"
                    placeholder="Owner password" />
                  <button type="button" onClick={() => setShow(s => !s)} aria-label="toggle visibility"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-200">
                    {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>

              {err && <div className="text-sm text-red-400">{err}</div>}

              <button type="submit" className="btn-lime w-full justify-center">Enter admin</button>
            </form>

            <p className="text-[11px] text-slate-500 mt-6 leading-relaxed">
              This area is restricted. All actions are visible only to the owner. Your session ends when you close this browser tab.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
